import { render, staticRenderFns } from "./SettingsSMTP.vue?vue&type=template&id=21af0f18&scoped=true&"
import script from "./SettingsSMTP.vue?vue&type=script&lang=js&"
export * from "./SettingsSMTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af0f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
